import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition, TransitionGroup } from 'react-transition-group';
import { shuffle } from 'lodash';

import { touchGestureDirections } from '../../constants/globals';
import asyncRoute from '../../helpers/hoc/asyncRoute';

import './UpsellItemCardStack.scss';
import gradientPeach from '../../assets/images/placeHolder/gradient-peach.svg';
import gradientPurple from '../../assets/images/placeHolder/gradient-purple.svg';
import gradientBlue from '../../assets/images/placeHolder/gradient-blue.svg';
import gradientGreen from '../../assets/images/placeHolder/gradient-green.svg';
import gradientYellow from '../../assets/images/placeHolder/gradient-yellow.svg';
import { upsellCardsTransitionDelay } from '../../constants/globals';

const UpsellItemCard = asyncRoute(() => import('../Card/UpsellItem'));
const TouchGesture = asyncRoute(() => import('../elements/TouchGesture'));

class UpsellItemCardStack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholderImages: [
        gradientPeach,
        gradientPurple,
        gradientBlue,
        gradientGreen,
        gradientYellow,
      ],
    };
  }

  componentDidMount() {
    this.setState((prevState) => ({
      placeholderImages: shuffle(prevState.placeholderImages), // Shuffle placehilder images to randomize their appearance
    }));
  }

  handlePassDealCTAClick = async (itemId, exhaustiblePlacehoderImage) => {
    await this.props.handlePassDealCTAClick(itemId);
    this.setState((prevState) => ({
      placeholderImages: prevState.placeholderImages.filter(
        (image) => image !== exhaustiblePlacehoderImage,
      ),
    }));
  };

  handleAddToCartCTAClick = (item) => {
    this.props.handleAddToCartCTAClick(item);
  };

  render() {
    const { items } = this.props;
    const { placeholderImages } = this.state;
    return (
      <div id="upsell-item-card-stack" className="upsell-item-card-stack">
        <TransitionGroup className="upsell-item-card-stack-inner-wrapper">
          {items.map((item, index, items) => {
            const defaultStyle = {
              zIndex: items.length - index,
              transform: `translateY(${index * 8}%) scale(${1 - index * 0.1})`,
              transition: `opacity 400ms ease-in-out, transform 400ms ease-in-out, z-index 400ms ease-in-out`,
            };

            const transitionStyles = {
              entering: { opacity: 1 },
              entered: { opacity: 1 },
              exiting: { opacity: 0, transform: `translateX(100vw) rotateZ(20deg)` },
            };

            return (
              <Transition key={item.id} timeout={upsellCardsTransitionDelay}>
                {(state) => (
                  <TouchGesture
                    onSwipe={() => this.handlePassDealCTAClick(item.id, placeholderImages[0])}
                    direction={touchGestureDirections.right}
                  >
                    <div
                      className="upsell-item-card-wrapper"
                      style={{ ...defaultStyle, ...(index === 0 && transitionStyles[state]) }}
                    >
                      <UpsellItemCard
                        item={item}
                        itemImagePlaceholder={placeholderImages[0]} // Since placeholderImages state contains already shuffled images, selecting any image, say first, will provide a random image
                        onPassDealCTAClick={() =>
                          this.handlePassDealCTAClick(item.id, placeholderImages[0])
                        }
                        onAddToCartCTAClick={() => this.handleAddToCartCTAClick(item)}
                      />
                    </div>
                  </TouchGesture>
                )}
              </Transition>
            );
          })}
        </TransitionGroup>
      </div>
    );
  }
}

UpsellItemCardStack.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

UpsellItemCardStack.defaultProps = {
  items: [],
};

export default UpsellItemCardStack;
